// extracted by mini-css-extract-plugin
export default {"root":"ImageUploadArea_root__kKkLM","active":"ImageUploadArea_active__l940B","content":"ImageUploadArea_content__lOe7F"};